import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Slim back bar for the top of every sub-page (About, FAQ, Privacy, etc.).
 * The arrow always returns to the landing page ("/").
 *
 * Usage: place <BackBar /> as the first element inside each sub-page component.
 */
export default function BackBar() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: '20px clamp(20px,5vw,56px)',
        maxWidth: 'var(--max-width)',
        margin: '0 auto',
        boxSizing: 'border-box',
      }}
    >
      <button
        type="button"
        onClick={() => navigate('/')}
        aria-label="Back to home"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          background: 'none',
          border: 'none',
          padding: '8px 4px',
          margin: 0,
          cursor: 'pointer',
          color: 'var(--text-300)',
          fontFamily: 'inherit',
          fontSize: '15px',
          fontWeight: 600,
          transition: 'color 0.2s',
          minHeight: '44px',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = 'var(--kachng-green)')}
        onMouseLeave={(e) => (e.currentTarget.style.color = 'var(--text-300)')}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
        Back
      </button>
    </div>
  );
}